import { useAuth0, RedirectLoginOptions } from '@auth0/auth0-react';
import { useCallback } from 'react';
import { getOrCreateSmartlookIdentifier } from './use-smartlook';

/**
 * A wrapper hook around Auth0's loginWithRedirect that automatically
 * injects the smartlook_id into the authorization params.
 */
const isLocalhost = () => {
  if (typeof window === 'undefined') return true;
  return window.location.hostname.match(/^(localhost|127\.|192\.168\.|0\.0\.0\.0)/);
};

export const useLoginWithRedirect = () => {
  const { loginWithRedirect: auth0LoginWithRedirect } = useAuth0();

  const loginWithRedirect = useCallback(
    (options?: RedirectLoginOptions) => {
      // Don't send smartlook_id on localhost
      if (isLocalhost()) {
        return auth0LoginWithRedirect(options);
      }

      const smartlookId = getOrCreateSmartlookIdentifier();

      return auth0LoginWithRedirect({
        ...options,
        authorizationParams: {
          ...options?.authorizationParams,
          smartlook_id: smartlookId,
        },
      });
    },
    [auth0LoginWithRedirect]
  );

  return { loginWithRedirect };
};
